import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { setPortal } from 'modules/portal';
import { userOnLogin } from 'lib/api/user';
import { spanningTable, commonGetParams } from 'lib/commonLib';
import { campaignManageLive } from 'lib/api/campaign';
import { showSuccessSnackbar } from 'modules/snackbar';

import NewTableContainer from 'components/molecules/NewTable';
import IconAreaWrap from 'components/molecules/MbTable/IconAreaWrap';
import SpanningTableContents from 'components/molecules/MbTable/SpanningTableContents';

const LiveStatistics = () => {
  const { t } = useTranslation();
  const { portal } = useSelector(({ portal }) => ({
    portal: portal,
  }));
  const dispatch = useDispatch();

  const initParam = {
    sort: 'asc',
    order: 'CONTACT_NAME',
  };
  const [params, setParams] = useState(initParam);

  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = { url: url, cnt: popIndex };
    dispatch(setPortal(newPortal));
  };

  const headData = {
    BANNER: [
      { key: 'BANNER_LC', label: t('라스트클릭') },
      { key: 'BANNER_TC', label: t('투데이카트') },
      { key: 'BANNER_WC', label: t('위클리카트') },
      { key: 'BANNER_MC', label: t('먼슬리카트') },
      { key: 'BANNER_CW', label: t('카트매칭') },
      { key: 'BANNER_OS', label: t('온사이트서치') },
      { key: 'BANNER_CH', label: t('커스텀하이') },
      { key: 'BANNER_CR', label: t('커스텀리타겟팅') },
      { key: 'BANNER_HV', label: t('원타임본상품') },
      { key: 'BANNER_HE', label: t('헤비리인게이지먼트') },
      { key: 'BANNER_TV', label: t('투데이본상품') },
      { key: 'BANNER_WV', label: t('위클리본상품') },
      { key: 'BANNER_MV', label: t('먼슬리본상품') },
      { key: 'BANNER_RC', label: t('관심상품') },
      { key: 'BANNER_SR', label: t('본상품') },
      { key: 'BANNER_TP', label: t('투데이보완재') },
      { key: 'BANNER_WP', label: t('위클리보완재') },
      { key: 'BANNER_SP', label: t('먼슬리보완재') },
      { key: 'BANNER_HR', label: t('원타임리턴') },
      { key: 'BANNER_TR', label: t('투데이리턴') },
      { key: 'BANNER_RE', label: t('리인게이지먼트') },
      { key: 'BANNER_WR', label: t('위클리리턴') },
      { key: 'BANNER_FR', label: t('먼슬리리턴') },
      { key: 'BANNER_HU', label: t('헤비유저') },
      { key: 'BANNER_RM', label: t('리턴') },
      { key: 'BANNER_ST', label: t('투데이베스트') },
      { key: 'BANNER_MT', label: t('문맥') },
      { key: 'BANNER_RU', label: t('휴면유저') },
      { key: 'BANNER_PU', label: t('위클리가망고객') },
      { key: 'BANNER_MU', label: t('먼슬리가망고객') },
      { key: 'BANNER_HM', label: t('헤비성향') },
      { key: 'BANNER_BP', label: t('가망고객') },
      { key: 'BANNER_TM', label: t('발신이력') },
      { key: 'BANNER_MO', label: t('미디어') },
      { key: 'BANNER_US', label: t('유저유사도') },
      { key: 'BANNER_UM', label: t('성향') },
      { key: 'BANNER_AT', label: t('앱프로파일') },
      { key: 'BANNER_AU', label: t('오디언스') },
      { key: 'BANNER_CM', label: t('카테고리') },
      { key: 'BANNER_PA', label: t('쇼라베이스') },
      { key: 'BANNER_AD', label: t('베이스광고') },
      { key: 'BANNER_SA', label: t('브랜드박스') },
      { key: 'BANNER_HP', label: t('하프보완재매칭') },
    ],
    BRAND: [
      { key: 'BRAND_UM', label: t('성향') },
      { key: 'BRAND_KL', label: t('검색어') },
      { key: 'BRAND_CM', label: t('카테고리') },
      { key: 'BRAND_AD', label: t('베이스광고') },
    ],
    ICOVER: [
      { key: 'ICOVER_TC', label: t('투데이카트') },
      { key: 'ICOVER_TV', label: t('투데이본상품') },
      { key: 'ICOVER_CW', label: t('카트매칭') },
      { key: 'ICOVER_SP', label: t('먼슬리보완재') },
      { key: 'ICOVER_RC', label: t('관심상품') },
      { key: 'ICOVER_SR', label: t('본상품') },
      { key: 'ICOVER_HU', label: t('헤비유저') },
      { key: 'ICOVER_RM', label: t('리턴') },
      { key: 'ICOVER_UM', label: t('성향') },
      { key: 'ICOVER_KL', label: t('검색어') },
      { key: 'ICOVER_AU', label: t('오디언스') },
      { key: 'ICOVER_CM', label: t('카테고리') },
      { key: 'ICOVER_AD', label: t('베이스광고') },
      { key: 'ICOVER_HP', label: t('하프보완재매칭') },
    ],
    NATIVE: [
      { key: 'NATIVE_TC', label: t('투데이카트') },
      { key: 'NATIVE_WC', label: t('위클리카트') },
      { key: 'NATIVE_MC', label: t('먼슬리카트') },
      { key: 'NATIVE_CW', label: t('카트매칭') },
      { key: 'NATIVE_RC', label: t('관심상품') },
      { key: 'NATIVE_SR', label: t('본상품') },
      { key: 'NATIVE_SP', label: t('보완재') },
      { key: 'NATIVE_HU', label: t('헤비유저') },
      { key: 'NATIVE_BP', label: t('가망고객') },
      { key: 'NATIVE_RM', label: t('리턴') },
      { key: 'NATIVE_MT', label: t('문맥') },
      { key: 'NATIVE_KL', label: t('검색어') },
      { key: 'NATIVE_UM', label: t('성향') },
      { key: 'NATIVE_AU', label: t('오디언스') },
      { key: 'NATIVE_CM', label: t('카테고리') },
      { key: 'NATIVE_AD', label: t('베이스광고') },
    ],
    PLUS: [
      { key: 'PLUS_PC', label: t('플러스콜매칭') },
      { key: 'PLUS_RT', label: t('콜리턴매칭') },
    ],
    PERF: [{ key: 'PERF', label: t('퍼포먼스광고') }],
  };

  // header 및 body 컬럼 커스텀
  const customized = {
    SITE_NAME: {
      makeBody: (rowObj) => {
        return (
          <IconAreaWrap
            text={rowObj['SITE_NAME']}
            icon="faSignInAlt"
            toolTipTitle={t('광고주 로그인')}
            onClick={(e) => handleOnLogin(rowObj.USER_ID)}
          />
        );
      },
    },
    BANNER_WEB_CW_GUBUN: {
      makeHead: (headsMap) => {
        return t('구분');
      },
      makeBody: (rowObj, headsMap) => {
        return (
          <>
            {t('웹')}
            <br />
            {t('모바일')}
          </>
        );
      },
      headStyle: { width: 40 },
    },
    BANNER_MOBILE_CW_GUBUN: {
      makeHead: (headsMap) => {
        return (
          <SpanningTableContents topTitle={t('배너')} type={'head'}>
            {spanningTable('campaignLiveHead', headData.BANNER)}
          </SpanningTableContents>
        );
      },
      makeBody: (rowObj, headsMap) => {
        let bodyData = [
          {
            key: 'BANNER_LC',
            topValue: rowObj['BANNER_WEB_LC_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_LC_GUBUN'],
          },
          {
            key: 'BANNER_TC',
            topValue: rowObj['BANNER_WEB_TC_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_TC_GUBUN'],
          },
          {
            key: 'BANNER_WC',
            topValue: rowObj['BANNER_WEB_WC_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_WC_GUBUN'],
          },
          {
            key: 'BANNER_MC',
            topValue: rowObj['BANNER_WEB_MC_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_MC_GUBUN'],
          },
          {
            key: 'BANNER_CW',
            topValue: rowObj['BANNER_WEB_CW_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_CW_GUBUN'],
          },
          {
            key: 'BANNER_OS',
            topValue: rowObj['BANNER_WEB_OS_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_OS_GUBUN'],
          },
          {
            key: 'BANNER_CH',
            topValue: rowObj['BANNER_WEB_CH_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_CH_GUBUN'],
          },
          {
            key: 'BANNER_CR',
            topValue: rowObj['BANNER_WEB_CR_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_CR_GUBUN'],
          },
          // 커스텀로우매칭
          {
            key: 'BANNER_TV',
            topValue: rowObj['BANNER_WEB_TV_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_TV_GUBUN'],
          },
          {
            key: 'BANNER_WV',
            topValue: rowObj['BANNER_WEB_WV_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_WV_GUBUN'],
          },
          {
            key: 'BANNER_MV',
            topValue: rowObj['BANNER_WEB_MV_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_MV_GUBUN'],
          },
          {
            key: 'BANNER_RC',
            topValue: rowObj['BANNER_WEB_RC_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_RC_GUBUN'],
          },
          {
            key: 'BANNER_SR',
            topValue: rowObj['BANNER_WEB_SR_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_SR_GUBUN'],
          },
          {
            key: 'BANNER_TP',
            topValue: rowObj['BANNER_WEB_TP_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_TP_GUBUN'],
          },
          {
            key: 'BANNER_WP',
            topValue: rowObj['BANNER_WEB_WP_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_WP_GUBUN'],
          },
          {
            key: 'BANNER_SP',
            topValue: rowObj['BANNER_WEB_SP_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_SP_GUBUN'],
          },
          {
            key: 'BANNER_TR',
            topValue: rowObj['BANNER_WEB_TR_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_TR_GUBUN'],
          },
          {
            key: 'BANNER_WR',
            topValue: rowObj['BANNER_WEB_WR_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_WR_GUBUN'],
          },
          {
            key: 'BANNER_FR',
            topValue: rowObj['BANNER_WEB_FR_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_FR_GUBUN'],
          },
          {
            key: 'BANNER_HU',
            topValue: rowObj['BANNER_WEB_HU_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_HU_GUBUN'],
          },
          {
            key: 'BANNER_RM',
            topValue: rowObj['BANNER_WEB_RM_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_RM_GUBUN'],
          },
          {
            key: 'BANNER_ST',
            topValue: rowObj['BANNER_WEB_ST_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_ST_GUBUN'],
          },
          {
            key: 'BANNER_MT',
            topValue: rowObj['BANNER_WEB_MT_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_MT_GUBUN'],
          },
          {
            key: 'BANNER_RU',
            topValue: rowObj['BANNER_WEB_RU_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_RU_GUBUN'],
          },
          {
            key: 'BANNER_BP',
            topValue: rowObj['BANNER_WEB_BP_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_BP_GUBUN'],
          },
          {
            key: 'BANNER_TM',
            topValue: rowObj['BANNER_WEB_TM_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_TM_GUBUN'],
          },
          {
            key: 'BANNER_MO',
            topValue: rowObj['BANNER_WEB_MO_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_MO_GUBUN'],
          },
          {
            key: 'BANNER_US',
            topValue: rowObj['BANNER_WEB_US_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_US_GUBUN'],
          },
          {
            key: 'BANNER_UM',
            topValue: rowObj['BANNER_WEB_UM_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_UM_GUBUN'],
          },
          {
            key: 'BANNER_AT',
            topValue: rowObj['BANNER_WEB_AT_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_AT_GUBUN'],
          },
          {
            key: 'BANNER_AU',
            topValue: rowObj['BANNER_WEB_AU_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_AU_GUBUN'],
          },
          {
            key: 'BANNER_CM',
            topValue: rowObj['BANNER_WEB_CM_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_CM_GUBUN'],
          },
          {
            key: 'BANNER_PA',
            topValue: rowObj['BANNER_WEB_PA_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_PA_GUBUN'],
          },
          {
            key: 'BANNER_AD',
            topValue: rowObj['BANNER_WEB_AD_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_AD_GUBUN'],
          },
          {
            key: 'BANNER_SA',
            topValue: rowObj['BANNER_WEB_SA_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_SA_GUBUN'],
          },
          {
            key: 'BANNER_HP',
            topValue: rowObj['BANNER_WEB_HP_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_HP_GUBUN'],
          },
          {
            key: 'BANNER_HV',
            topValue: rowObj['BANNER_WEB_HV_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_HV_GUBUN'],
          },
          {
            key: 'BANNER_HR',
            topValue: rowObj['BANNER_WEB_HR_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_HR_GUBUN'],
          },
          {
            key: 'BANNER_HM',
            topValue: rowObj['BANNER_WEB_HM_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_HM_GUBUN'],
          },
          {
            key: 'BANNER_PU',
            topValue: rowObj['BANNER_WEB_PU_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_PU_GUBUN'],
          },
          {
            key: 'BANNER_MU',
            topValue: rowObj['BANNER_WEB_MU_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_MU_GUBUN'],
          },
          {
            key: 'BANNER_HE',
            topValue: rowObj['BANNER_WEB_HE_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_HE_GUBUN'],
          },
          {
            key: 'BANNER_RE',
            topValue: rowObj['BANNER_WEB_RE_GUBUN'],
            bottomValue: rowObj['BANNER_MOBILE_RE_GUBUN'],
          },
        ];
        return (
          <SpanningTableContents>
            {spanningTable('campaignLive', bodyData)}
          </SpanningTableContents>
        );
      },
      headStyle: {
        borderLeft: '1px solid #e0e0e0',
        borderRight: '1px solid #e0e0e0',
      },
      bodyStyle: {
        borderLeft: '1px solid #e0e0e0',
        borderRight: '1px solid #e0e0e0',
      },
    },
    BANNER_WEB_LC_GUBUN: { merged: true },
    BANNER_MOBILE_LC_GUBUN: { merged: true },
    BANNER_WEB_TC_GUBUN: { merged: true },
    BANNER_MOBILE_TC_GUBUN: { merged: true },
    BANNER_WEB_SR_GUBUN: { merged: true },
    BANNER_MOBILE_SR_GUBUN: { merged: true },
    BANNER_WEB_WV_GUBUN: { merged: true },
    BANNER_MOBILE_WV_GUBUN: { merged: true },
    BANNER_WEB_WR_GUBUN: { merged: true },
    BANNER_MOBILE_WR_GUBUN: { merged: true },
    BANNER_WEB_RC_GUBUN: { merged: true },
    BANNER_MOBILE_RC_GUBUN: { merged: true },
    BANNER_WEB_SP_GUBUN: { merged: true },
    BANNER_MOBILE_SP_GUBUN: { merged: true },
    BANNER_WEB_ST_GUBUN: { merged: true },
    BANNER_MOBILE_ST_GUBUN: { merged: true },
    BANNER_WEB_HU_GUBUN: { merged: true },
    BANNER_MOBILE_HU_GUBUN: { merged: true },
    BANNER_WEB_RM_GUBUN: { merged: true },
    BANNER_MOBILE_RM_GUBUN: { merged: true },
    BANNER_WEB_MT_GUBUN: { merged: true },
    BANNER_MOBILE_MT_GUBUN: { merged: true },
    BANNER_WEB_RU_GUBUN: { merged: true },
    BANNER_MOBILE_RU_GUBUN: { merged: true },
    BANNER_WEB_MO_GUBUN: { merged: true },
    BANNER_MOBILE_MO_GUBUN: { merged: true },
    BANNER_WEB_US_GUBUN: { merged: true },
    BANNER_MOBILE_US_GUBUN: { merged: true },
    BANNER_WEB_UM_GUBUN: { merged: true },
    BANNER_MOBILE_UM_GUBUN: { merged: true },
    BANNER_WEB_BP_GUBUN: { merged: true },
    BANNER_MOBILE_BP_GUBUN: { merged: true },
    BANNER_WEB_AT_GUBUN: { merged: true },
    BANNER_MOBILE_AT_GUBUN: { merged: true },
    BANNER_WEB_AU_GUBUN: { merged: true },
    BANNER_MOBILE_AU_GUBUN: { merged: true },
    BANNER_WEB_CM_GUBUN: { merged: true },
    BANNER_MOBILE_CM_GUBUN: { merged: true },
    BANNER_WEB_PA_GUBUN: { merged: true },
    BANNER_MOBILE_PA_GUBUN: { merged: true },
    BANNER_WEB_AD_GUBUN: { merged: true },
    BANNER_MOBILE_AD_GUBUN: { merged: true },
    BANNER_WEB_SA_GUBUN: { merged: true },
    BANNER_MOBILE_SA_GUBUN: { merged: true },
    BANNER_WEB_HP_GUBUN: { merged: true },
    BANNER_MOBILE_HP_GUBUN: { merged: true },
    BANNER_WEB_CR_GUBUN: { merged: true },
    BANNER_MOBILE_CR_GUBUN: { merged: true },
    BANNER_WEB_MV_GUBUN: { merged: true },
    BANNER_MOBILE_MV_GUBUN: { merged: true },
    BANNER_WEB_TR_GUBUN: { merged: true },
    BANNER_MOBILE_TR_GUBUN: { merged: true },
    BANNER_WEB_FR_GUBUN: { merged: true },
    BANNER_MOBILE_FR_GUBUN: { merged: true },
    BANNER_WEB_OS_GUBUN: { merged: true },
    BANNER_MOBILE_OS_GUBUN: { merged: true },
    BANNER_WEB_CH_GUBUN: { merged: true },
    BANNER_MOBILE_CH_GUBUN: { merged: true },
    BANNER_WEB_TP_GUBUN: { merged: true },
    BANNER_MOBILE_TP_GUBUN: { merged: true },
    BANNER_WEB_WP_GUBUN: { merged: true },
    BANNER_MOBILE_WP_GUBUN: { merged: true },
    BANNER_WEB_TM_GUBUN: { merged: true },
    BANNER_MOBILE_TM_GUBUN: { merged: true },
    BANNER_WEB_HV_GUBUN: { merged: true },
    BANNER_MOBILE_HV_GUBUN: { merged: true },
    BANNER_WEB_HR_GUBUN: { merged: true },
    BANNER_MOBILE_HR_GUBUN: { merged: true },
    BANNER_WEB_HM_GUBUN: { merged: true },
    BANNER_MOBILE_HM_GUBUN: { merged: true },
    BANNER_WEB_PU_GUBUN: { merged: true },
    BANNER_MOBILE_PU_GUBUN: { merged: true },
    BANNER_WEB_MU_GUBUN: { merged: true },
    BANNER_MOBILE_MU_GUBUN: { merged: true },
    BANNER_WEB_HE_GUBUN: { merged: true },
    BANNER_MOBILE_HE_GUBUN: { merged: true },
    BANNER_WEB_RE_GUBUN: { merged: true },
    BANNER_MOBILE_RE_GUBUN: { merged: true },
    BRAND_WEB_UM_GUBUN: {
      makeHead: (headsMap) => {
        return (
          <SpanningTableContents topTitle={t('브랜드커버')} type={'head'}>
            {spanningTable('campaignLiveHead', headData.BRAND)}
          </SpanningTableContents>
        );
      },
      makeBody: (rowObj, headsMap) => {
        let bodyData = [
          {
            key: 'BRAND_UM',
            topValue: rowObj['BRAND_WEB_UM_GUBUN'],
            bottomValue: rowObj['BRAND_MOBILE_UM_GUBUN'],
          },
          {
            key: 'BRAND_KL',
            topValue: rowObj['BRAND_WEB_KL_GUBUN'],
            bottomValue: rowObj['BRAND_MOBILE_KL_GUBUN'],
          },
          {
            key: 'BRAND_CM',
            topValue: rowObj['BRAND_WEB_CM_GUBUN'],
            bottomValue: rowObj['BRAND_MOBILE_CM_GUBUN'],
          },
          {
            key: 'BRAND_AD',
            topValue: rowObj['BRAND_WEB_AD_GUBUN'],
            bottomValue: rowObj['BRAND_MOBILE_AD_GUBUN'],
          },
        ];
        return (
          <SpanningTableContents>
            {spanningTable('campaignLive', bodyData)}
          </SpanningTableContents>
        );
      },
      headStyle: { borderRight: '1px solid #e0e0e0' },
      bodyStyle: { borderRight: '1px solid #e0e0e0' },
    },
    BRAND_MOBILE_UM_GUBUN: { merged: true },
    BRAND_WEB_KL_GUBUN: { merged: true },
    BRAND_MOBILE_KL_GUBUN: { merged: true },
    BRAND_WEB_CM_GUBUN: { merged: true },
    BRAND_MOBILE_CM_GUBUN: { merged: true },
    BRAND_WEB_AD_GUBUN: { merged: true },
    BRAND_MOBILE_AD_GUBUN: { merged: true },
    ICOVER_WEB_CW_GUBUN: {
      makeHead: (headsMap) => {
        return (
          <SpanningTableContents topTitle={t('아이커버')} type={'head'}>
            {spanningTable('campaignLiveHead', headData.ICOVER)}
          </SpanningTableContents>
        );
      },
      makeBody: (rowObj, headsMap) => {
        let bodyData = [
          {
            key: 'ICOVER_TC',
            topValue: rowObj['ICOVER_WEB_TC_GUBUN'],
            bottomValue: rowObj['ICOVER_MOBILE_TC_GUBUN'],
          },
          {
            key: 'ICOVER_TV',
            topValue: rowObj['ICOVER_WEB_TV_GUBUN'],
            bottomValue: rowObj['ICOVER_MOBILE_TV_GUBUN'],
          },
          {
            key: 'ICOVER_CW',
            topValue: rowObj['ICOVER_WEB_CW_GUBUN'],
            bottomValue: rowObj['ICOVER_MOBILE_CW_GUBUN'],
          },
          {
            key: 'ICOVER_SP',
            topValue: rowObj['ICOVER_WEB_SP_GUBUN'],
            bottomValue: rowObj['ICOVER_MOBILE_SP_GUBUN'],
          },
          {
            key: 'ICOVER_RC',
            topValue: rowObj['ICOVER_WEB_RC_GUBUN'],
            bottomValue: rowObj['ICOVER_MOBILE_RC_GUBUN'],
          },
          {
            key: 'ICOVER_SR',
            topValue: rowObj['ICOVER_WEB_SR_GUBUN'],
            bottomValue: rowObj['ICOVER_MOBILE_SR_GUBUN'],
          },

          {
            key: 'ICOVER_HU',
            topValue: rowObj['ICOVER_WEB_HU_GUBUN'],
            bottomValue: rowObj['ICOVER_MOBILE_HU_GUBUN'],
          },
          {
            key: 'ICOVER_RM',
            topValue: rowObj['ICOVER_WEB_RM_GUBUN'],
            bottomValue: rowObj['ICOVER_MOBILE_RM_GUBUN'],
          },
          {
            key: 'ICOVER_UM',
            topValue: rowObj['ICOVER_WEB_UM_GUBUN'],
            bottomValue: rowObj['ICOVER_MOBILE_UM_GUBUN'],
          },
          {
            key: 'ICOVER_KL',
            topValue: rowObj['ICOVER_WEB_KL_GUBUN'],
            bottomValue: rowObj['ICOVER_MOBILE_KL_GUBUN'],
          },
          {
            key: 'ICOVER_AU',
            topValue: rowObj['ICOVER_WEB_AU_GUBUN'],
            bottomValue: rowObj['ICOVER_MOBILE_AU_GUBUN'],
          },
          {
            key: 'ICOVER_CM',
            topValue: rowObj['ICOVER_WEB_CM_GUBUN'],
            bottomValue: rowObj['ICOVER_MOBILE_CM_GUBUN'],
          },
          {
            key: 'ICOVER_AD',
            topValue: rowObj['ICOVER_WEB_AD_GUBUN'],
            bottomValue: rowObj['ICOVER_MOBILE_AD_GUBUN'],
          },
          {
            key: 'ICOVER_HP',
            topValue: rowObj['ICOVER_WEB_HP_GUBUN'],
            bottomValue: rowObj['ICOVER_MOBILE_HP_GUBUN'],
          },
        ];
        return (
          <SpanningTableContents>
            {spanningTable('campaignLive', bodyData)}
          </SpanningTableContents>
        );
      },
      headStyle: { width: 252, borderRight: '1px solid #e0e0e0' },
      bodyStyle: { borderRight: '1px solid #e0e0e0' },
    },
    ICOVER_MOBILE_CW_GUBUN: { merged: true },
    ICOVER_WEB_SR_GUBUN: { merged: true },
    ICOVER_MOBILE_SR_GUBUN: { merged: true },
    ICOVER_WEB_RC_GUBUN: { merged: true },
    ICOVER_MOBILE_RC_GUBUN: { merged: true },
    ICOVER_WEB_SP_GUBUN: { merged: true },
    ICOVER_MOBILE_SP_GUBUN: { merged: true },
    ICOVER_WEB_HU_GUBUN: { merged: true },
    ICOVER_MOBILE_HU_GUBUN: { merged: true },
    ICOVER_WEB_RM_GUBUN: { merged: true },
    ICOVER_MOBILE_RM_GUBUN: { merged: true },
    ICOVER_WEB_UM_GUBUN: { merged: true },
    ICOVER_MOBILE_UM_GUBUN: { merged: true },
    ICOVER_WEB_KL_GUBUN: { merged: true },
    ICOVER_MOBILE_KL_GUBUN: { merged: true },
    ICOVER_WEB_AU_GUBUN: { merged: true },
    ICOVER_MOBILE_AU_GUBUN: { merged: true },
    ICOVER_WEB_CM_GUBUN: { merged: true },
    ICOVER_MOBILE_CM_GUBUN: { merged: true },
    ICOVER_WEB_AD_GUBUN: { merged: true },
    ICOVER_MOBILE_AD_GUBUN: { merged: true },
    ICOVER_WEB_TV_GUBUN: { merged: true },
    ICOVER_MOBILE_TV_GUBUN: { merged: true },

    ICOVER_WEB_HP_GUBUN: { merged: true },
    ICOVER_MOBILE_HP_GUBUN: { merged: true },

    NATIVE_WEB_CW_GUBUN: {
      makeHead: (headsMap) => {
        return (
          <SpanningTableContents topTitle={t('네이티브')} type={'head'}>
            {spanningTable('campaignLiveHead', headData.NATIVE)}
          </SpanningTableContents>
        );
      },
      makeBody: (rowObj, headsMap) => {
        let bodyData = [
          {
            key: 'NATIVE_TC',
            topValue: rowObj['NATIVE_WEB_TC_GUBUN'],
            bottomValue: rowObj['NATIVE_MOBILE_TC_GUBUN'],
          },
          {
            key: 'NATIVE_WC',
            topValue: rowObj['NATIVE_WEB_WC_GUBUN'],
            bottomValue: rowObj['NATIVE_MOBILE_WC_GUBUN'],
          },
          {
            key: 'NATIVE_CW',
            topValue: rowObj['NATIVE_WEB_CW_GUBUN'],
            bottomValue: rowObj['NATIVE_MOBILE_CW_GUBUN'],
          },
          {
            key: 'NATIVE_MC',
            topValue: rowObj['NATIVE_WEB_MC_GUBUN'],
            bottomValue: rowObj['NATIVE_MOBILE_MC_GUBUN'],
          },
          {
            key: 'NATIVE_RC',
            topValue: rowObj['NATIVE_WEB_RC_GUBUN'],
            bottomValue: rowObj['NATIVE_MOBILE_RC_GUBUN'],
          },
          {
            key: 'NATIVE_SR',
            topValue: rowObj['NATIVE_WEB_SR_GUBUN'],
            bottomValue: rowObj['NATIVE_MOBILE_SR_GUBUN'],
          },
          {
            key: 'NATIVE_SP',
            topValue: rowObj['NATIVE_WEB_SP_GUBUN'],
            bottomValue: rowObj['NATIVE_MOBILE_SP_GUBUN'],
          },
          {
            key: 'NATIVE_HU',
            topValue: rowObj['NATIVE_WEB_HU_GUBUN'],
            bottomValue: rowObj['NATIVE_MOBILE_HU_GUBUN'],
          },
          {
            key: 'NATIVE_BP',
            topValue: rowObj['NATIVE_WEB_BP_GUBUN'],
            bottomValue: rowObj['NATIVE_MOBILE_BP_GUBUN'],
          },
          {
            key: 'NATIVE_RM',
            topValue: rowObj['NATIVE_WEB_RM_GUBUN'],
            bottomValue: rowObj['NATIVE_MOBILE_RM_GUBUN'],
          },
          {
            key: 'NATIVE_MT',
            topValue: rowObj['NATIVE_WEB_MT_GUBUN'],
            bottomValue: rowObj['NATIVE_MOBILE_MT_GUBUN'],
          },
          {
            key: 'NATIVE_KL',
            topValue: rowObj['NATIVE_WEB_KL_GUBUN'],
            bottomValue: rowObj['NATIVE_MOBILE_KL_GUBUN'],
          },
          {
            key: 'NATIVE_UM',
            topValue: rowObj['NATIVE_WEB_UM_GUBUN'],
            bottomValue: rowObj['NATIVE_MOBILE_UM_GUBUN'],
          },
          {
            key: 'NATIVE_AU',
            topValue: rowObj['NATIVE_WEB_AU_GUBUN'],
            bottomValue: rowObj['NATIVE_MOBILE_AU_GUBUN'],
          },
          {
            key: 'NATIVE_CM',
            topValue: rowObj['NATIVE_WEB_CM_GUBUN'],
            bottomValue: rowObj['NATIVE_MOBILE_CM_GUBUN'],
          },
          {
            key: 'NATIVE_AD',
            topValue: rowObj['NATIVE_WEB_AD_GUBUN'],
            bottomValue: rowObj['NATIVE_MOBILE_AD_GUBUN'],
          },
        ];
        return (
          <SpanningTableContents>
            {spanningTable('campaignLive', bodyData)}
          </SpanningTableContents>
        );
      },
      headStyle: { borderRight: '1px solid #e0e0e0' },
      bodyStyle: { borderRight: '1px solid #e0e0e0' },
    },
    PLUS_WEB_PC_GUBUN: {
      makeHead: (headsMap) => {
        return (
          <SpanningTableContents topTitle={t('플러스콜')} type={'head'}>
            {spanningTable('campaignLiveHead', headData.PLUS)}
          </SpanningTableContents>
        );
      },
      makeBody: (rowObj, headsMap) => {
        let bodyData = [
          {
            key: 'PLUS_PC',
            topValue: rowObj['PLUS_WEB_PC_GUBUN'],
            bottomValue: rowObj['PLUS_MOBILE_PC_GUBUN'],
          },
          {
            key: 'PLUS_RT',
            topValue: rowObj['PLUS_WEB_RT_GUBUN'],
            bottomValue: rowObj['PLUS_MOBILE_RT_GUBUN'],
          },
        ];
        return (
          <SpanningTableContents>
            {spanningTable('campaignLive', bodyData)}
          </SpanningTableContents>
        );
      },
      headStyle: { borderRight: '1px solid #e0e0e0' },
      bodyStyle: { borderRight: '1px solid #e0e0e0' },
    },
    PERF_WEB_PF_GUBUN: {
      makeHead: (headsMap) => {
        return (
          <SpanningTableContents topTitle={t('퍼포먼스')} type={'head'}>
            {spanningTable('campaignLiveHead', headData.PERF)}
          </SpanningTableContents>
        );
      },
      makeBody: (rowObj, headsMap) => {
        let bodyData = [
          {
            key: 'PLUS_PC',
            topValue: rowObj['PERF_WEB_PF_GUBUN'],
            bottomValue: rowObj['PERF_MOBILE_PF_GUBUN'],
          },
        ];
        return (
          <SpanningTableContents>
            {spanningTable('campaignLive', bodyData)}
          </SpanningTableContents>
        );
      },
      headStyle: { borderRight: '1px solid #e0e0e0' },
      bodyStyle: { borderRight: '1px solid #e0e0e0' },
    },
    NATIVE_WEB_TC_GUBUN: { merged: true },
    NATIVE_MOBILE_TC_GUBUN: { merged: true },
    NATIVE_MOBILE_CW_GUBUN: { merged: true },
    NATIVE_WEB_RC_GUBUN: { merged: true },
    NATIVE_MOBILE_RC_GUBUN: { merged: true },
    NATIVE_WEB_SR_GUBUN: { merged: true },
    NATIVE_MOBILE_SR_GUBUN: { merged: true },
    NATIVE_WEB_SP_GUBUN: { merged: true },
    NATIVE_MOBILE_SP_GUBUN: { merged: true },
    NATIVE_WEB_HU_GUBUN: { merged: true },
    NATIVE_MOBILE_HU_GUBUN: { merged: true },
    NATIVE_WEB_RM_GUBUN: { merged: true },
    NATIVE_MOBILE_RM_GUBUN: { merged: true },
    NATIVE_WEB_UM_GUBUN: { merged: true },
    NATIVE_MOBILE_UM_GUBUN: { merged: true },
    NATIVE_WEB_AU_GUBUN: { merged: true },
    NATIVE_MOBILE_AU_GUBUN: { merged: true },
    NATIVE_WEB_CM_GUBUN: { merged: true },
    NATIVE_MOBILE_CM_GUBUN: { merged: true },
    NATIVE_WEB_AD_GUBUN: { merged: true },
    NATIVE_MOBILE_AD_GUBUN: { merged: true },
    BANNER_WEB_WC_GUBUN: { merged: true },
    BANNER_MOBILE_WC_GUBUN: { merged: true },
    BANNER_WEB_TV_GUBUN: { merged: true },
    BANNER_MOBILE_TV_GUBUN: { merged: true },
    BANNER_WEB_MC_GUBUN: { merged: true },
    BANNER_MOBILE_MC_GUBUN: { merged: true },
    ICOVER_WEB_TC_GUBUN: { merged: true },
    ICOVER_MOBILE_TC_GUBUN: { merged: true },
    NATIVE_WEB_MT_GUBUN: { merged: true },
    NATIVE_MOBILE_MT_GUBUN: { merged: true },
    NATIVE_WEB_KL_GUBUN: { merged: true },
    NATIVE_MOBILE_KL_GUBUN: { merged: true },
    NATIVE_WEB_WC_GUBUN: { merged: true },
    NATIVE_MOBILE_WC_GUBUN: { merged: true },
    NATIVE_WEB_MC_GUBUN: { merged: true },
    NATIVE_MOBILE_MC_GUBUN: { merged: true },
    NATIVE_WEB_BP_GUBUN: { merged: true },
    NATIVE_MOBILE_BP_GUBUN: { merged: true },
    PLUS_MOBILE_PC_GUBUN: { merged: true },
    PLUS_WEB_RT_GUBUN: { merged: true },
    PLUS_MOBILE_RT_GUBUN: { merged: true },
    PERF_MOBILE_PF_GUBUN: { merged: true },
  };

  /**
   * 로그인처리
   */
  const handleOnLogin = (ADVER_ID) => {
    userOnLogin(ADVER_ID, 'manage')
      .then((response) => {
        const { data, success } = response.data;
        if (success) {
          handlePortalUrl(data.url);
        } else {
          handleClickSnackbar({
            message: t('로그인에 실패했습니다. 관리자에게 문의하세요.'),
            option: {
              type: 'error',
            },
          });
        }
      })
      .catch((error) => {
        handleClickSnackbar({
          message: error,
          option: {
            type: 'error',
          },
        });
      });
  };

  const getParam = (newParams, name) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(commonGetParams(params, newParams, name));
    }
  };

  const handleClickSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    //eslint-disable-next-line
  }, []);

  return (
    <NewTableContainer
      params={params}
      getParam={getParam}
      dataReqPromise={campaignManageLive}
      customized={customized}
      useTotal={false}
      useFetch={false}
      rowsPerPage={200}
    />
  );
};

export default LiveStatistics;
